// FolderToggle.js
import React,{useContext} from "react";
import { BiCollection } from "react-icons/bi";
import { VscFolderOpened } from "react-icons/vsc";
import GlobalContext from "contexts/context";
import { isMobileTablet } from "hooks/helper";


// const FolderToggle = ({ toggleFolders }) => {
//   const { globalState } = useContext(GlobalContext);


//   return (
//     <div
//       className={
//         isMobileTablet()
//           ? "UI-main-screen-fab-mobile"
//           : "UI-main-screen-fab"
//       }
//       title="Toggle Folders/Collections"
//       onClick={toggleFolders}
//     >
//       {globalState?.prefs?.showFolders ? (
//         <BiCollection size={20} />
//       ) : (
//         <VscFolderOpened size={20} />
//       )}
//     </div>
//   );
// };

// export default FolderToggle;

const FolderToggle = React.memo(({ toggleFolders }) => {
  const { globalState } = useContext(GlobalContext);
  
  return (
    <div
      className={isMobileTablet() ? "UI-main-screen-fab-mobile" : "UI-main-screen-fab"}
      title="Toggle Folders/Collections"
      onClick={toggleFolders}
    >
      {globalState?.prefs?.showFolders ? (
        <BiCollection strokeWidth={1} size={20} />
      ) : (
        <VscFolderOpened strokeWidth={1} size={20} />
      )}
    </div>
  );
}, (prevProps, nextProps) => false); // Always re-render when props change

export default FolderToggle;